import SatisfactionMessage from './SatisfactionMessage';

export default SatisfactionMessage;
